import { render, staticRenderFns } from "./iconPowerBank.vue?vue&type=template&id=8bfe3764&scoped=true"
import script from "./iconPowerBank.vue?vue&type=script&lang=js"
export * from "./iconPowerBank.vue?vue&type=script&lang=js"
import style0 from "./iconPowerBank.vue?vue&type=style&index=0&id=8bfe3764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfe3764",
  null
  
)

export default component.exports